export default __webpack_public_path__ + "static/media/storno-form-mobile.dfb38553.PNG";